import styled from "styled-components/macro";
import { ReactComponent as BlueSuccess } from "assets/svgs/blue-success.svg";

export const FlexColumn = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));

export const MainContent = styled.div(({ theme }) => ({
  marginTop: "50px",
  display: "flex",
  flexDirection: "column",
  borderBottom: `1px solid ${theme.color.line.medium}`,
  [theme.breakpoint.lg()]: {
    flexDirection: "row",
  },
}));

export const StyledBlueSuccess = styled(BlueSuccess)(({ theme }) => ({
  margin: "0 32px 24px 0",
}));
